import Dashboard from '../containers/dashboard'
import NewInsightsManagement from '../containers/new-insights-management'

const Insights = () => {
  return (
    <Dashboard>
      <NewInsightsManagement />
    </Dashboard>
  )
}

export default Insights
